import React from 'react';
import { formatProjectsTrialLabel, getProjectsAccess, ProjectsCompany } from '../../utils/projectsAccess';

const ProjectsTrialBanner: React.FC<{ company?: ProjectsCompany }> = ({ company }) => {
  const access = getProjectsAccess(company);
  if (access.kind !== 'trial' || !access.endsAt) {
    return null;
  }
  const trial = formatProjectsTrialLabel(access.endsAt);
  return (
    <div className={`projects-trial-banner${trial.daysLeft <= 1 ? ' is-ending' : ''}`}>
      <div>
        <strong>Projects demo</strong>
        <p>
          {trial.label} — until {trial.dateLabel}. After that the module locks unless Uptimio unlocks it for your company.
        </p>
      </div>
      <span className="projects-trial-chip">{trial.label}</span>
    </div>
  );
};

export default ProjectsTrialBanner;
